<template>
<img src="../../assets/instagram.png">
</template>

<script>
    export default {
        name: "YoutubeIcon"
    }
</script>

<style scoped>

</style>
